import awards from "../../shared/fr.awards";
import branded_quotes from "../../shared/fr.branded-quotes";
import verticals from "./fr-enterprise.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "fr-enterprise-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.com/entreprises/contact/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-enterprise-home":
            return {
                page,
                helmet: {
                    meta_title: "Formation en langues  des affaires | Rosetta Stone",
                    meta_description:
                        "Les solutions de formation de Rosetta Stone aident les employés à acquérir des compétences linguistiques en anglais des affaires et bien d’autres langues étrangères.",
                    canonical_url: "https://www.rosettastone.fr/entreprises/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-enterprise-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Formation globale linguistique pour les affaires | Rosetta Stone Catalyst",
                    meta_description:
                        "La formation globale linguistique pour les affaires de Rosetta Stone Catalyst offre des cours dans les principales langues des affaires que les employés peuvent apprendre où qu’ils se trouvent.  Demandez nos tarifs pour entreprises.",
                    canonical_url: "https://www.rosettastone.fr/entreprises/solutions/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-enterprise-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-enterprise-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "Site non trouvé | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/business/404",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
